<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      title="交通模拟"
      id="vehicleSimulation"
      :close="trafficClose"
    >
      <template slot="content">
        <!-- <el-form class="settings" label-width="80px">
          <el-form-item label="交通量：" class="">
            <el-select
              v-model="period"
              placeholder=""
              :popper-append-to-body="false"
            >
              <el-option label="高峰" :value="3.5"></el-option>
              <el-option label="平时" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="正向：" class="">
            <el-select
              v-model="just"
              placeholder="请选择"
              :popper-append-to-body="false"
            >
              <el-option label="不展示" :value="false"></el-option>
              <el-option label="第一车道行驶" :value="1"></el-option>
              <el-option label="第二车道行驶" :value="2"></el-option>
              <el-option label="第三车道行驶" :value="3"></el-option>
              <el-option label="多车道行驶" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="反向：" class="">
            <el-select
              v-model="opposite"
              placeholder="请选择"
              :popper-append-to-body="false"
            >
              <el-option label="不展示" :value="false"></el-option>
              <el-option label="第一车道行驶" :value="1"></el-option>
              <el-option label="第二车道行驶" :value="2"></el-option>
              <el-option label="第三车道行驶" :value="3"></el-option>
              <el-option label="多车道行驶" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" " class="btns">
            <el-button type="primary" plain @click="mapInit(false)" class="but"
              >车辆模拟</el-button
            >
          </el-form-item>
          <el-form-item label=" " class="btns">
            <el-button type="primary" plain @click="mapInit(true)" class="but"
              >多车道多模型模拟</el-button
            >
          </el-form-item>
        </el-form> -->
        <fixedRoute></fixedRoute>
      </template>
    </MapModal>
  </div>
</template>
<script>
export let map; // mars3d.Map三维地图对象
export let graphicLayer; // 矢量图层对象
// import { EventBus } from "../../../static/js/event-bus.js";
const MapModal = () => import("@/components/common/mapModal/Index");
import fixedRoute from "../fixedRoute/fixedRoute.vue";
//按需加载
export default {
  name: "vehicle-simulation",
  props: {},
  components: { MapModal, fixedRoute },
  data() {
    return {
      options1: {
        car1: {
          name: "群演-不紧不慢",
          entity: null,
          gltf: "gltf/cart/jiaobanche.glb",
          coordinateArr: [
            {
              coordinate: [113.56834388, 23.11558577, 19],
            },
            {
              coordinate: [113.56834387, 23.11558578, 19],
            },
            {
              coordinate: [113.568053, 23.115897, 19.9],
            },
            {
              coordinate: [113.567529, 23.1165, 20.7],
            },
            {
              coordinate: [113.567215, 23.116934, 21.1],
            },
            {
              coordinate: [113.566549, 23.1179, 21.5],
            },
          ],
        },
        car1_2: {
          name: "群演-不紧不慢",
          entity: null,
          gltf: "gltf/cart/kache3.gltf",
          // gltf: "gltf/cart/jiaobanche.glb",
          coordinateArr: [
            {
              coordinate: [113.568456, 23.115462, 19],
            },
            {
              coordinate: [113.568455, 23.115463, 19],
            },
            {
              coordinate: [113.568454, 23.115464, 19],
            },
            {
              coordinate: [113.568053, 23.115897, 19.9],
            },
            {
              coordinate: [113.567529, 23.1165, 20.7],
            },
            {
              coordinate: [113.566915, 23.117373, 21.2],
            },
            {
              coordinate: [113.566275, 23.118311, 21.5],
            },
          ],
        },
        car2: {
          name: "群众-前面车太慢",
          entity: null,
          gltf: "gltf/cart/benchi1.gltf",
          coordinateArr: [
            {
              coordinate: [113.56855, 23.11537, 18.8],
            },
            {
              coordinate: [113.568149, 23.115787, 19.7],
            },
            {
              coordinate: [113.567556, 23.116433, 20.7],
            },
            {
              coordinate: [113.566796, 23.117471, 21.5],
            },
            {
              coordinate: [113.566082, 23.118541, 21.7],
            },
          ],
        },
        car2_2: {
          name: "群众-前面车太慢",
          entity: null,
          gltf: "gltf/cart/red_car.gltf",
          coordinateArr: [
            {
              coordinate: [113.568555, 23.115304, 18.9],
            },
            {
              coordinate: [113.568186, 23.115699, 19.7],
            },
            {
              coordinate: [113.567653, 23.116306, 20.5],
            },
            {
              coordinate: [113.566912, 23.117309, 21.4],
            },
            {
              coordinate: [113.566082, 23.118541, 21.7],
            },
          ],
        },
        car3: {
          name: "群众-赶集忙慌",
          gltf: "gltf/cart/red_car.gltf",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.568346, 23.115531, 19.3],
            },
            {
              coordinate: [113.567497, 23.116496, 20.7],
            },
            {
              coordinate: [113.566503, 23.117911, 21.6],
            },
          ],
        },
        car4: {
          name: "群众-我走我的",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.568309, 23.115513, 19.5],
            },
            {
              coordinate: [113.56782, 23.116065, 20.4],
            },
            {
              coordinate: [113.567137, 23.116928, 21.2],
            },
            {
              coordinate: [113.566466, 23.117899, 21.8],
            },
          ],
        },
        car5: {
          name: "群众-我走我的2",
          entity: null,
          gltf: "gltf/cart/suv.gltf",
          coordinateArr: [
            { coordinate: [113.568309, 23.115513, 19.5] },
            { coordinate: [113.568308, 23.115514, 19.5] },
            {
              coordinate: [113.56782, 23.116065, 20.4],
            },
            {
              coordinate: [113.567137, 23.116928, 21.2],
            },
            {
              coordinate: [113.566466, 23.117899, 21.8],
            },
          ],
        },
        car6: {
          name: "群众-我走我的3",
          entity: null,
          gltf: "gltf/cart/bus2.gltf",
          coordinateArr: [
            { coordinate: [113.568309, 23.115513, 19.5] },
            { coordinate: [113.568308, 23.115514, 19.5] },
            { coordinate: [113.568307, 23.115515, 19.5] },
            {
              coordinate: [113.56782, 23.116065, 20.4],
            },
            {
              coordinate: [113.567137, 23.116928, 21.2],
            },
            {
              coordinate: [113.566466, 23.117899, 21.8],
            },
          ],
        },
        car7: {
          name: "群众-别理我我转弯",
          entity: null,
          coordinateArr: [
            { coordinate: [113.568432, 23.115544, 19] },
            { coordinate: [113.567852, 23.116241, 20] },
            { coordinate: [113.567427, 23.117065, 20.3] },
            { coordinate: [113.567259, 23.117842, 20.6] },
          ],
        },
        car8: {
          name: "群众-我也想转弯",
          entity: null,
          gltf: "gltf/cart/zhatuche.glb",
          coordinateArr: [
            {
              coordinate: [113.568456, 23.115462, 19],
            },
            {
              coordinate: [113.568456, 23.115462, 19],
            },
            {
              coordinate: [113.568011, 23.115993, 19.8],
            },
            { coordinate: [113.56766, 23.11655, 19.9] },
            { coordinate: [113.567477, 23.11694, 20.2] },
            { coordinate: [113.567269, 23.117673, 20.5] },
          ],
        },
        car9: {
          name: "群众-别理我我转弯2",
          entity: null,
          coordinateArr: [
            { coordinate: [113.568432, 23.115544, 19] },
            { coordinate: [113.568431, 23.115545, 19] },
            { coordinate: [113.56843, 23.115546, 19] },
            { coordinate: [113.567852, 23.116241, 20] },
            { coordinate: [113.567415, 23.117099, 20.4] },
            { coordinate: [113.567259, 23.117842, 20.6] },
          ],
        },
        car11: {
          name: "群演11",
          entity: null,
          gltf: "gltf/cart/red_car.gltf",
          coordinateArr: [
            {
              coordinate: [113.565926, 23.118428, 21.8],
            },
            {
              coordinate: [113.566623, 23.117446, 21.7],
            },
            {
              coordinate: [113.567311, 23.116581, 21.1],
            },
            {
              coordinate: [113.567881, 23.115891, 20.3],
            },
          ],
        },
        car12: {
          name: "群演12",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565892, 23.118424, 21.8],
            },
            {
              coordinate: [113.566555, 23.117487, 21.8],
            },
            {
              coordinate: [113.567245, 23.116606, 21.3],
            },
            {
              coordinate: [113.567879, 23.115853, 20.4],
            },
          ],
        },
        car13: {
          name: "群演13",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car11_2: {
          name: "群演11",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.565681, 23.118802, 21.8],
            },
            {
              coordinate: [113.566274, 23.117915, 21.8],
            },
            {
              coordinate: [113.566869, 23.117133, 21.16],
            },
            {
              coordinate: [113.567544, 23.116298, 20.8],
            },
            {
              coordinate: [113.568087, 23.115673, 20],
            },
          ],
        },
        car12_2: {
          name: "群演12",
          entity: null,
          gltf: "gltf/cart/red_car.gltf",
          coordinateArr: [
            {
              coordinate: [113.56564, 23.1188, 21.8],
            },
            {
              coordinate: [113.56619, 23.117981, 21.8],
            },
            {
              coordinate: [113.566809, 23.117148, 21.8],
            },
            {
              coordinate: [113.567555, 23.116238, 20.9],
            },
            {
              coordinate: [113.568056, 23.115658, 20.1],
            },
          ],
        },
        car13_2: {
          name: "群演13",
          entity: null,
          gltf: "gltf/cart/suv.gltf",
          coordinateArr: [
            {
              coordinate: [113.565595, 23.118796, 21.6],
            },
            {
              coordinate: [113.566146, 23.117978, 21.8],
            },
            {
              coordinate: [113.566807, 23.117085, 21.9],
            },
            {
              coordinate: [113.567518, 23.116221, 21],
            },
            {
              coordinate: [113.568019, 23.115639, 20.3],
            },
          ],
        },

        car14: {
          name: "群演14",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.565926, 23.118428, 21.8],
            },
            {
              coordinate: [113.565926, 23.118428, 21.8],
            },
            {
              coordinate: [113.566623, 23.117446, 21.7],
            },
            {
              coordinate: [113.567311, 23.116581, 21.1],
            },
            {
              coordinate: [113.567881, 23.115891, 20.3],
            },
          ],
        },
        car15: {
          name: "群演15",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565892, 23.118424, 21.8],
            },
            {
              coordinate: [113.565892, 23.118424, 21.8],
            },
            {
              coordinate: [113.566555, 23.117487, 21.8],
            },
            {
              coordinate: [113.567245, 23.116606, 21.3],
            },
            {
              coordinate: [113.567879, 23.115853, 20.4],
            },
          ],
        },
        car16: {
          name: "群演16",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },

        car14_2: {
          name: "群演11",
          entity: null,
          gltf: "gltf/cart/bus2.gltf",
          coordinateArr: [
            {
              coordinate: [113.565681, 23.118802, 21.8],
            },
            {
              coordinate: [113.565681, 23.118802, 21.8],
            },
            {
              coordinate: [113.566274, 23.117915, 21.8],
            },
            {
              coordinate: [113.566869, 23.117133, 21.16],
            },
            {
              coordinate: [113.567544, 23.116298, 20.8],
            },
            {
              coordinate: [113.568087, 23.115673, 20],
            },
          ],
        },
        car15_2: {
          name: "群演12",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.56564, 23.1188, 21.8],
            },
            {
              coordinate: [113.56564, 23.1188, 21.8],
            },
            {
              coordinate: [113.56619, 23.117981, 21.8],
            },
            {
              coordinate: [113.566809, 23.117148, 21.8],
            },
            {
              coordinate: [113.567555, 23.116238, 20.9],
            },
            {
              coordinate: [113.568056, 23.115658, 20.1],
            },
          ],
        },
        car16_2: {
          name: "群演13",
          entity: null,
          gltf: "gltf/cart/kache3.gltf",
          coordinateArr: [
            {
              coordinate: [113.565595, 23.118796, 21.6],
            },
            {
              coordinate: [113.565595, 23.118796, 21.6],
            },
            {
              coordinate: [113.566146, 23.117978, 21.8],
            },
            {
              coordinate: [113.566807, 23.117085, 21.9],
            },
            {
              coordinate: [113.567518, 23.116221, 21],
            },
            {
              coordinate: [113.568019, 23.115639, 20.3],
            },
          ],
        },

        car17: {
          name: "群演17",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.565926, 23.118428, 21.8],
            },
            {
              coordinate: [113.565926, 23.118428, 21.8],
            },
            {
              coordinate: [113.565926, 23.118428, 21.8],
            },
            {
              coordinate: [113.566623, 23.117446, 21.7],
            },
            {
              coordinate: [113.567311, 23.116581, 21.1],
            },
            {
              coordinate: [113.567881, 23.115891, 20.3],
            },
          ],
        },
        car18: {
          name: "群演18",
          gltf: "gltf/cart/kache1.gltf",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.565892, 23.118424, 21.8],
            },
            {
              coordinate: [113.565892, 23.118424, 21.8],
            },
            {
              coordinate: [113.565892, 23.118424, 21.8],
            },
            {
              coordinate: [113.566555, 23.117487, 21.8],
            },
            {
              coordinate: [113.567245, 23.116606, 21.3],
            },
            {
              coordinate: [113.567879, 23.115853, 20.4],
            },
          ],
        },
        car19: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car20: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car21: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car22: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car23: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car24: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car25: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car26: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car27: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car28: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car29: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car30: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car31: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car32: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car33: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car34: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
        car35: {
          name: "群演19",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
      },
      options2: {},
      options3: {
        car1: {
          name: "群演-不紧不慢",
          entity: null,
          gltf: "gltf/cart/jiaobanche.glb",
          coordinateArr: [
            {
              coordinate: [113.568456, 23.115462, 19],
            },
            {
              coordinate: [113.568053, 23.115897, 19.9],
            },
            {
              coordinate: [113.567529, 23.1165, 20.7],
            },
            {
              coordinate: [113.567215, 23.116934, 21.1],
            },
            {
              coordinate: [113.566549, 23.1179, 21.5],
            },
          ],
        },
        car3: {
          name: "群众-赶集忙慌",
          gltf: "gltf/cart/red_car.gltf",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.568346, 23.115531, 19.3],
            },
            {
              coordinate: [113.567497, 23.116496, 20.7],
            },
            {
              coordinate: [113.566503, 23.117911, 21.6],
            },
          ],
        },
        car4: {
          name: "群众-我走我的",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.568309, 23.115513, 19.5],
            },
            {
              coordinate: [113.56782, 23.116065, 20.4],
            },
            {
              coordinate: [113.567137, 23.116928, 21.2],
            },
            {
              coordinate: [113.566466, 23.117899, 21.8],
            },
          ],
        },
        car6: {
          name: "群众-我走我的3",
          entity: null,
          coordinateArr: [
            { coordinate: [113.568309, 23.115513, 19.5] },
            { coordinate: [113.568309, 23.115513, 19.5] },
            { coordinate: [113.568309, 23.115513, 19.5] },
            {
              coordinate: [113.56782, 23.116065, 20.4],
            },
            {
              coordinate: [113.567137, 23.116928, 21.2],
            },
            {
              coordinate: [113.566466, 23.117899, 21.8],
            },
          ],
        },
        car7: {
          name: "群众-别理我我转弯",
          entity: null,
          coordinateArr: [
            { coordinate: [113.568432, 23.115544, 19] },
            { coordinate: [113.567852, 23.116241, 20] },
            { coordinate: [113.567427, 23.117065, 20.3] },
            { coordinate: [113.567259, 23.117842, 20.6] },
          ],
        },

        car9: {
          name: "群众-别理我我转弯2",
          entity: null,
          coordinateArr: [
            { coordinate: [113.568432, 23.115544, 19] },
            { coordinate: [113.568432, 23.115544, 19] },
            { coordinate: [113.568432, 23.115544, 19] },
            { coordinate: [113.567852, 23.116241, 20] },
            { coordinate: [113.567415, 23.117099, 20.4] },
            { coordinate: [113.567259, 23.117842, 20.6] },
          ],
        },
        car11: {
          name: "群演11",
          gltf: "gltf/cart/kache1.gltf",
          entity: null,
          coordinateArr: [
            {
              coordinate: [113.565926, 23.118428, 21.8],
            },
            {
              coordinate: [113.566623, 23.117446, 21.7],
            },
            {
              coordinate: [113.567311, 23.116581, 21.1],
            },
            {
              coordinate: [113.567881, 23.115891, 20.3],
            },
          ],
        },
        car12: {
          name: "群演12",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565892, 23.118424, 21.8],
            },
            {
              coordinate: [113.566555, 23.117487, 21.8],
            },
            {
              coordinate: [113.567245, 23.116606, 21.3],
            },
            {
              coordinate: [113.567879, 23.115853, 20.4],
            },
          ],
        },
        car13: {
          name: "群演13",
          entity: null,
          gltf: "gltf/cart/xiaofangche.gltf",
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566552, 23.117419, 21.8],
            },
            {
              coordinate: [113.567171, 23.116633, 21.1],
            },
            {
              coordinate: [113.567874, 23.115808, 20.4],
            },
          ],
        },
      },
      lane: {
        just_1: {
          coordinateArr: [
            {
              coordinate: [113.568456, 23.115462, 19],
            },
            {
              coordinate: [113.567518, 23.11653, 20.6],
            },
            {
              coordinate: [113.566549, 23.1179, 21.5],
            },
          ],
        },
        just_2: {
          coordinateArr: [
            {
              coordinate: [113.568428, 23.115443, 19],
            },
            {
              coordinate: [113.567493, 23.116517, 20.6],
            },
            {
              coordinate: [113.566515, 23.117896, 21.5],
            },
          ],
        },
        just_3: {
          coordinateArr: [
            {
              coordinate: [113.568389, 23.115427, 19],
            },
            {
              coordinate: [113.567449, 23.116506, 20.6],
            },
            {
              coordinate: [113.566473, 23.117895, 21.5],
            },
          ],
        },
        just_4: {
          just_1: {
            coordinateArr: [
              {
                coordinate: [113.568456, 23.115462, 19],
              },
              {
                coordinate: [113.567518, 23.11653, 20.6],
              },
              {
                coordinate: [113.566549, 23.1179, 21.5],
              },
            ],
          },
          just_2: {
            coordinateArr: [
              {
                coordinate: [113.568428, 23.115443, 19],
              },
              {
                coordinate: [113.567493, 23.116517, 20.6],
              },
              {
                coordinate: [113.566515, 23.117896, 21.5],
              },
            ],
          },
          just_3: {
            coordinateArr: [
              {
                coordinate: [113.568389, 23.115427, 19],
              },
              {
                coordinate: [113.567449, 23.116506, 20.6],
              },
              {
                coordinate: [113.566473, 23.117895, 21.5],
              },
            ],
          },
        },
        opposite_1: {
          coordinateArr: [
            {
              coordinate: [113.565926, 23.118428, 21.8],
            },
            {
              coordinate: [113.566623, 23.117446, 21.7],
            },
            {
              coordinate: [113.567311, 23.116581, 21.1],
            },
            {
              coordinate: [113.567881, 23.115891, 20.4],
            },
          ],
        },
        opposite_2: {
          coordinateArr: [
            {
              coordinate: [113.565892, 23.118424, 21.8],
            },
            {
              coordinate: [113.5666, 23.117433, 21.8],
            },
            {
              coordinate: [113.567283, 23.116564, 21.3],
            },
            {
              coordinate: [113.567853, 23.115878, 20.4],
            },
          ],
        },
        opposite_3: {
          coordinateArr: [
            {
              coordinate: [113.565837, 23.118429, 21.8],
            },
            {
              coordinate: [113.566554, 23.117424, 21.8],
            },
            {
              coordinate: [113.567243, 23.116548, 21.3],
            },
            {
              coordinate: [113.56783, 23.11585, 20.4],
            },
          ],
        },
        opposite_4: {
          opposite_1: {
            coordinateArr: [
              {
                coordinate: [113.565926, 23.118428, 21.8],
              },
              {
                coordinate: [113.566623, 23.117446, 21.7],
              },
              {
                coordinate: [113.567311, 23.116581, 21.1],
              },
              {
                coordinate: [113.567881, 23.115891, 20.4],
              },
            ],
          },
          opposite_2: {
            coordinateArr: [
              {
                coordinate: [113.565892, 23.118424, 21.8],
              },
              {
                coordinate: [113.5666, 23.117433, 21.8],
              },
              {
                coordinate: [113.567283, 23.116564, 21.3],
              },
              {
                coordinate: [113.567853, 23.115878, 20.4],
              },
            ],
          },
          opposite_3: {
            coordinateArr: [
              {
                coordinate: [113.565837, 23.118429, 21.8],
              },
              {
                coordinate: [113.566554, 23.117424, 21.8],
              },
              {
                coordinate: [113.567243, 23.116548, 21.3],
              },
              {
                coordinate: [113.56783, 23.11585, 20.4],
              },
            ],
          },
        },
      },
      totalNumber: 6,
      period: 3.5,
      just: 1,
      opposite: false,
      cycleRun: null,
      modalNode: {
        viewpointTour: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 120,
            y: -370,
            // unit: "px", // 默认px
          },
          width: "300px", // 宽度配置 默认450px
          height: `340px`, // 配置模态框中心高度
          // height: "350px",
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    mapInit(state) {
      console.log(this.$GLOBAL.map.getCameraView());
      // this.$GLOBAL.map.centerAt({
      //   y: 23.115166,
      //   x: 113.567388,
      //   alt: 210,
      //   heading: 16,
      //   pitch: -49,
      // });
      graphicLayer = null;
      graphicLayer = new mars3d.layer.GraphicLayer();
      this.$GLOBAL.map.addLayer(graphicLayer);
      clearInterval(this.cycleRun);
      this.cycleRun = null;
      console.log(state);
      let item;
      Object.keys(this.options1).forEach((key, l) => {
        item = this.options1[key];
        if (item.entity) {
          item.entity.clearDynamicPosition();
          item.entity.destroy();
        }
        item.entity = null;
      });
      Object.keys(this.options2).forEach((key, l) => {
        item = this.options2[key];
        if (item.entity) {
          item.entity.clearDynamicPosition();
          item.entity.destroy();
        }
        item.entity = null;
      });
      Object.keys(this.options3).forEach((key, l) => {
        item = this.options3[key];
        if (item.entity) {
          item.entity.clearDynamicPosition();
          item.entity.destroy();
        }
        item.entity = null;
      });
      if (state) {
        if (this.period == 3.5) {
          this.addVehicle(this.options1, true);
        } else {
          this.addVehicle(this.options3, true);
        }
      } else {
        this.period = 3.5;
        this.addVehicle2();
      }
    },
    addVehicle2() {
      this.options2 = {};
      if (this.just) {
        if (this.just != 4) {
          this.options2["just_" + this.just] = this.lane["just_" + this.just];
        } else {
          Object.keys(this.lane["just_" + this.just]).forEach((key) => {
            this.options2[key] = this.lane["just_" + this.just][key];
          });
        }
      }
      if (this.opposite) {
        if (this.opposite != 4) {
          this.options2["opposite_" + this.opposite] = this.lane[
            "opposite_" + this.opposite
          ];
        } else {
          Object.keys(this.lane["opposite_" + this.opposite]).forEach((key) => {
            this.options2[key] = this.lane["opposite_" + this.opposite][key];
          });
        }
      }
      this.addVehicle(this.options2, false);
    },
    addVehicle(laneData, cycle) {
      let item;
      let basePathUrl = window.basePathUrl || "";
      Object.keys(laneData).forEach((key, l) => {
        item = laneData[key];
        // 删除对象
        if (item.entity) {
          item.entity.clearDynamicPosition();
          item.entity.destroy();
        }
        item.entity = null;
        item.entity = new mars3d.graphic.ModelEntity({
          name: "车",
          style: {
            url: item.gltf
              ? basePathUrl + item.gltf
              : basePathUrl + "gltf/cart/aodi1.gltf",
            scale: 1,
            minimumPixelSize: 1,
            maximumScale: 1,
            distanceDisplayCondition: true,
            distanceDisplayCondition_near: 0,
            distanceDisplayCondition_far: 10000,
            mergeOrientation: true,
            highlight: {
              type: mars3d.EventType.click,
              silhouette: true,
              silhouetteColor: "#ff0000",
              silhouetteSize: 4,
            },
            // heading: 10,
            label: {
              text: "鄂A" + l,
              font_size: 16,
              font_family: "黑体",
              color: "#ffffff",
              outline: true,
              outlineColor: "#000000",
              pixelOffsetY: -50,
              distanceDisplayCondition: true,
              distanceDisplayCondition_far: 50000,
              distanceDisplayCondition_near: 0,
            },
          },
          zhang_scenes: item.coordinateArr,
        });
        graphicLayer.addGraphic(item.entity);
        item.entity.on(mars3d.EventType.stop, function(event) {
          console.log("已停止运行");
        });
      });
      let index = 1;
      this.initCar();

      this.cycleRun = setInterval(() => {
        index += 1;
        if (index >= this.totalNumber) {
          clearInterval(this.cycleRun);
          this.cycleRun = null;
          console.log("最后一秒");
          if (cycle) {
            if (this.period == 3.5) {
              this.addVehicle(this.options1, true);
            } else {
              this.addVehicle(this.options3, true);
            }
          }
        } else {
          graphicLayer.eachGraphic((graphic) => {
            if (
              graphic.options.zhang_scenes[index] &&
              graphic.options.zhang_scenes[index].coordinate != undefined
            ) {
              let [x, y, z] = graphic.options.zhang_scenes[index].coordinate;
              graphic.addDynamicPosition(
                Cesium.Cartesian3.fromDegrees(x, y, z),
                this.period
              );
            } else {
              graphic.clearDynamicPosition();
              // graphic.destroy();
            }
          });
        }
      }, this.period * 1000);
    },
    initCar() {
      console.log("初始化");
      graphicLayer.eachGraphic((graphic) => {
        if (graphic.options.zhang_scenes[0]) {
          let [x, y, z] = graphic.options.zhang_scenes[0].coordinate;
          graphic.addDynamicPosition(Cesium.Cartesian3.fromDegrees(x, y, z));
        }
      });
      graphicLayer.eachGraphic((graphic) => {
        if (graphic.options.zhang_scenes[1]) {
          let [x, y, z] = graphic.options.zhang_scenes[1].coordinate;
          graphic.addDynamicPosition(
            Cesium.Cartesian3.fromDegrees(x, y, z),
            this.period
          );
        }
      });
    },

    trafficClose() {
      this.$emit("videoSurveilBox_close");
    },
    init() {
      // this.$GLOBAL.map.centerAt({
      //   y: 23.115166,
      //   x: 113.567388,
      //   alt: 210,
      //   heading: 16,
      //   pitch: -49,
      // });
      graphicLayer = null;
      clearInterval(this.cycleRun);
      this.cycleRun = null;
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
  destroyed() {
    graphicLayer.remove();
    clearInterval(this.cycleRun);
    this.cycleRun = null;
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.el-form.settings {
  width: 100%;
  padding: 8px 36px 17px 0;
  /deep/ .el-form-item {
    width: 100%;
    padding: 0 0 0 18px;
    margin-bottom: 18px;
    .el-form-item__label {
      min-height: 1px;
      margin-bottom: 0px;
      font-size: 12px;
      @include font_color("t_color_op1");
      padding: 0;
      line-height: 32px;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      line-height: 32px;
      .el-select {
        @include select_base();
      }
      .el-input {
        @include input_base();
        width: auto !important;
      }
      .el-textarea {
        @include textarea_base();
      }
      .el-checkbox {
        @include checkbox_base();
      }
    }
    .el-input__inner {
      width: 100% !important;
    }
    .el-input-group__prepend {
      border-color: rgba(245, 245, 245, 0.6) !important;
      color: rgba(255, 255, 255, 0.9) !important;
      background: none;
      padding: 0 10px;
    }
    &.btns {
      padding: 6px 0 0 89px;
      .el-form-item__content {
        width: 166px;
        .el-button--primary {
          @include lheight(28);
          @include font_color("t_color_op1");
          @include background_color("t_color1_op2");
          @include border_color("t_color1_op2");
          padding: 0 15px;
          margin: 6px 16px 0 0;
          span {
            @include lheight(28);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color1_op1");
            @include border_color("t_color1_op1");
          }
          &.is-disabled {
            @include font_color("t_color_sc1");
            @include background_color("t_color1_op3");
            @include border_color("t_color1_op3");
            span {
              background: none;
              @include font_color("t_color_sc1");
            }
          }
        }
        .el-button--default {
          @include lheight(28);
          @include font_color("t_color_op2");
          @include background_color("t_color3_op2");
          @include border_color("t_color_op2");
          padding: 0 15px;
          margin: 6px 16px 0 6px;
          span {
            @include lheight(24);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color3_op1");
            @include border_color("t_color_op1");
            @include font_color("t_color_op1");
          }
        }
      }
    }
    &:first-child {
      padding: 10px 0 0 18px;
    }
  }
  .el-form-item.btns {
    // padding: 0;
    // margin: 0;
    .el-form-item__content .el-button--primary {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .rich {
    /deep/ .el-form-item__label {
      float: none;
    }
    /deep/ .el-form-item__content {
      width: 100% !important;
      margin: 0 !important;
    }
  }
  .el-popper[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: #fff !important;
  }
}
</style>
